import React from 'react';
import {useParams} from "react-router";
import {useFormData} from "../../hooks";
import cls from './draft-page.module.scss';
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";

const Draft = () => {
    const {root_code, id:formId} = useParams()
    const isEditMode = `${formId}`.startsWith('rec')
    const {data:response,original:formDataOrig} = useFormData( `${formId}_submission_response`)  || {} as any
    const toEditUrl = (url, recId) => {
        if(isEditMode)return url
        url += (url.includes('?') ? '&' : '?') + `__refresh_edit__=${recId}`
        return url
    }

    const editUrl = toEditUrl(response.href, response.record.tableRecordId);

    return <div className={cls.wrapper}>
           <h1>Save as Draft</h1>
           <h5 className='mt-3'>Your form has been saved. To revisit this form in the future, use the following URL:</h5>
           <InputText style={{width:'100%'}} readOnly={true} id='edit_url_input_text'  value={editUrl} />
            <p
            className={
                'cursor-pointer underline mt-10 mr-2 text-primary'
            } onClick={() => {navigator.clipboard.writeText(editUrl).then(() => {console.log('Copied')});}}>Copy Url</p>
        <div className={cls.btnWrapper}>
            <Button onClick={() => window.location.href = editUrl}>Continue Editing</Button>
        </div>

    </div>

}

export default Draft;
